<div class="info-box-component {{ type }}">
  <div class="icon-wrapper">
    <mat-icon svgIcon="info-circle"></mat-icon>
  </div>
  <div [innerHTML]="text" class="text-wrapper sub-heading-m"></div>
</div>
